export const getEnv = async () => {
  // Renvoie un objet vide si non défini pour éviter les TypeError
  return window._env_ || {};
};